import React from "react";
import { FaTwitter, FaLinkedin } from 'react-icons/fa'; // Assuming you have the FontAwesome library installed

export default function Contact() {
  return (
    <section id="contact" className="relative">
      <div className="container px-5 py-10 mx-auto color-black">
        <div className="bg-gray-900 rounded-lg overflow-hidden p-10 text-center">
          <div className="bg-gray-900 relative flex flex-wrap py-6 rounded shadow-md">
            <div className="lg:w-full px-6 mt-4 lg:mt-0">
              <h2 className="title-font font-semibold text-white tracking-widest text-base">
                Ahmed Ahres
              </h2>
              <a href="mailto:ahmedahres98@gmail.com" className="text-indigo-400 leading-relaxed">
                ahmedahres98@gmail.com
              </a>
              <div className="mt-4 flex items-center justify-center">
                <a href="https://twitter.com/Boudatw" target="_blank" rel="noopener noreferrer" className="text-indigo-400">
                  <FaTwitter size={30} />
                </a>
                <a href="https://www.linkedin.com/in/ahmedahres/" target="_blank" rel="noopener noreferrer" className="text-indigo-400 ml-4">
                  <FaLinkedin size={30} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/components/Contact.js